<div class="auth-layout">
  <router-outlet></router-outlet>
</div>
